module.exports = new __parcel__URL__("deployments-preview-dark.0cf1d99c.svg").toString();